import * as angular from 'angular';

class SecondaryCounterpartyDetailsSectionComponentCtrl
    implements ng.IController
{
    ownProposal: boolean;
    proposal: ProposalDto;
    response: ResponseDto;

    $onInit() {}
}

angular.module('app').component('pkpSecondaryCounterpartyDetailsSection', {
    controller: SecondaryCounterpartyDetailsSectionComponentCtrl,
    template:
        require('app/secondary-trading/secondary-counterparty-details-section.component.html'),
    bindings: {
        ownProposal: '<',
        proposal: '<',
        response: '<'
    }
});
